import { Breadcrumbs, FormControl, InputLabel, Link, MenuItem, Select, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import FormContainer from "../../../../../common/components/form_container"
import AlertError from "../../../../../common/components/alert_error"
import { BackButton } from "../../../../../common/components/back_button"
import { CadastroEmpreendimentoModal } from "./components/cadastro_empreendimento_modal"
import { DefaultAutocomplete } from "../../../../../common/components/default_autocomplete"
import { useEmpreendimentoCadastroViewModel } from "../../viewModels/empreendimento_cadastro_view_model"
import DefaultFormInput from "../../../../../common/components/default_form_input"
import BottomBar from "../../../../../common/components/bottom_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { isValidId } from "../../../../../common/utils/utils"
import { IncorporacaoBlocoTableEditable } from "./components/incorporacao_bloco_table_editable"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { DefaultMultiAutocomplete } from "../../../../../common/components/default_multi_autocomplete"
import { CopyBlocoModal } from "./components/copy_bloco_modal"
import { CadastroUnidadesBlocoModal } from "./components/cadastro_unidades_bloco_modal"
import { Link as LinkTo } from 'react-router';
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"

export const EmpreendimentoCadastro = () => {
    const viewModel = useEmpreendimentoCadastroViewModel();

    const selectedTeste = useMemo(() => {
        return viewModel.listCentroCustoDropDown?.find(x => x.id === viewModel.idCentroCusto) ?? null
    }, [viewModel.listCentroCustoDropDown, viewModel.idCentroCusto])

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="w-full justify-end flex flex-row gap-2">
                            <div>
                                <BackButton
                                    onClick={viewModel.handlePageBack} />
                            </div>
                        </div>
                    }
                />
            </PageTopBar>
            <form className="pb-8" onSubmit={viewModel.handleUpdateEmpreendimentoSubmit}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Incorporação
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to='/Empreendimento_lista'>  Empreendimento Lista </LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Cadastro Incorporação
                        </Typography>
                    </Breadcrumbs>
                    <div>
                        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                            <div className="flex gap-2 items-center w-full">
                                <h1 className="text-3xl font-medium text-black dark:text-white"> Empreendimento Incorporação</h1>
                                <RefreshButton onClick={() => { } /*viewModel.handleReload */} />
                            </div>

                        </div>
                        {viewModel.selectedEmpreendimento && (
                            <div className="w-full mt-2 text-black dark:text-white">
                                <span className="font-extrabold text-xl mr-2">Centro Custo: </span>
                                <span className="mx-1 font-bold text-xl">{viewModel.selectedEmpreendimento.nomeCentroCusto}</span>
                            </div>
                        )}
                    </div>

                    {
                        "" === undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={""}
                                    onTryAgain={() => { }} />
                            </div>
                        ) : (
                            <>
                            </>
                        )
                    }
                    <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
                        <FormContainer title='Cadastro de Incorporação' arrangement='fullRow' border={false}>
                            <div className="flex flex-row items-start w-full gap-4">

                                <div className="flex flex-col w-2/4 gap-4">
                                    <DefaultAutocomplete
                                        label='Centro de Custo'
                                        options={viewModel.listCentroCustoDropDown ?? []}
                                        required={true}
                                        helperText={viewModel.hookForm.formState.errors.idCentroCusto?.message}
                                        readOnly={viewModel.selectedIdEmpreendimento !== null}
                                        getOptionLabel={(opt) => opt.title}
                                        getOptionKey={(opt) => opt.id}
                                        value={selectedTeste}
                                        onChange={x => viewModel.handleCentroCustoDropDownChange(x?.id ?? null)}
                                    />

                                    <DefaultFormInput
                                        name='descricao'
                                        label='Descriçao'
                                        reactHookForm={viewModel.hookForm}
                                        required={true}

                                    />

                                    <FormControl size="medium" fullWidth>
                                        <InputLabel id="modulo-dashboard">Tipo Empreendimento *</InputLabel>
                                        <Select
                                            labelId="modulo-dashboard"
                                            label="Tipo Empreendimento"
                                            required={true}
                                            value={viewModel.tipo ?? 0}
                                            readOnly={viewModel.selectedIdEmpreendimento !== null}
                                            onChange={(e) => viewModel.handleCadastroEmpreendimentoOpenState(Number(e.target.value), true)}>
                                            <MenuItem value={0}>Selecionar</MenuItem>
                                            <MenuItem value={1}>Apartamento</MenuItem>
                                            <MenuItem value={2}>Casa</MenuItem>
                                            <MenuItem value={3}>Outro</MenuItem>
                                        </Select>
                                    </FormControl>
                                    {
                                        viewModel.selectedIdEmpreendimento !== null &&
                                        (
                                            <DefaultMultiAutocomplete
                                                options={viewModel.listBlocoDropDown}
                                                value={viewModel.listBlocoDropDown.filter((i) => viewModel.selectedBlocosDropDown.includes(i.id))}
                                                getOptionLabel={(i) => i.title}
                                                getOptionKey={(x) => x.id}
                                                onChange={(newValue) => {
                                                    const selectedIds = newValue?.map((i) => i.id) ?? [];
                                                    viewModel.handleEmpreendimentoBlocoDropDownChange(selectedIds);
                                                }}
                                            />
                                        )
                                    }
                                    {
                                        viewModel.selectedIdEmpreendimento !== null &&
                                        (<div className="w-full justify-start flex flex-col gap-2">
                                            <div className="w-[220px] ">
                                                <PrimaryButton
                                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                                    onClick={() => viewModel.handleCadastroEmpreendimentoOpenState(viewModel.tipo || (viewModel.selectedEmpreendimento?.tipo ?? 0), true)}>
                                                    Nova Área
                                                </PrimaryButton>
                                            </div>
                                        </div>)
                                    }
                                </div>
                                {
                                    viewModel.selectedIdEmpreendimento !== null &&
                                    (<div className="flex flex-col w-2/4 gap-4">
                                        <DefaultFormInput
                                            name='apresentacao'
                                            label='Apresentação'
                                            multiline
                                            minRows={10}
                                            maxRows={20}
                                            reactHookForm={viewModel.hookForm}
                                            required={false}
                                        />
                                    </div>)
                                }
                            </div>
                        </FormContainer>

                        {viewModel.listBlocoCompleteTable?.list.map((item, index) => (
                            <IncorporacaoBlocoTableEditable
                                key={index}
                                blocoTable={item}
                                setListBlocoCompleteTable={viewModel.setListBlocoCompleteTable}
                                selectedBlocoAlteracao={viewModel.selectedBlocoAlteracao}
                                selectedUnidadeAlteracao={viewModel.selectedUnidadeAlteracao}
                                setSelectedBlocoAlteracao={viewModel.setSelectedBlocoAlteracao}
                                setSelectedUnidadeAlteracao={viewModel.setSelectedUnidadeAlteracao}
                                onDoubleClickBloco={viewModel.handleSelectBlocoAlteracao}
                                onDoubleClickUnidade={viewModel.handleSelectUnidadeAlteracao}
                                onBlocoTitleChange={viewModel.handleBlocoTitleChange}
                                onUnidadeTitleChange={viewModel.handleUnidadeTitleChange}
                                onOpenDeleteModal={viewModel.handleBlocoDeleteOpenState}
                                onOpenCopyModal={viewModel.handleCopyBlocoOpenState}
                                onOpenUnidadesModal={viewModel.handleCadastroUnidadesOpenState}
                                onOpenDeleteUnidadeModal={viewModel.handleUnidadeDeleteOpenState}

                            />
                        ))}

                    </div>
                </div>
                <BottomBar>
                    <div className="relative w-full h-full items-center justify-between flex p-4">
                        <div>
                            {
                                isValidId(viewModel.selectedIdEmpreendimento) &&
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                                    <span className="text-xs">
                                        Historico de alterações
                                    </span>
                                </PrimaryButton>
                            }
                        </div>

                        {/* Centralizada na barra, independente da largura dos botões laterais. */}
                        {viewModel.possuiAlteracaoUnidades && (
                            <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1 text-sm font-semibold text-red-500">
                                <DynamicIcon nameIcon="WarningAmberRounded" size={20} className="text-red-500" />
                                <span>Ao editar o nome da área, clicar no botão salvar!</span>
                            </div>
                        )}

                        <div className="flex flex-row gap-4">
                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1
                                    className="text-sm text-black dark:text-white"
                                    onClick={viewModel.handlePageBack}>
                                    Cancelar
                                </h1>
                            </div>
                            <div className="w-[130px]">
                                {viewModel.saving
                                    ? (
                                        <PrimaryButton>
                                            Salvando...
                                        </PrimaryButton>
                                    ) : (
                                        <PrimaryButton
                                            type="submit"
                                            startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                                            Salvar
                                        </PrimaryButton>
                                    )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form>

            <CadastroEmpreendimentoModal
                open={viewModel.openCadastroModal}
                saving={viewModel.saving}
                idEmpreendimento={0}
                selectedIdCentroCusto={viewModel.idCentroCusto}
                selectedTipo={viewModel.tipo || (viewModel.selectedEmpreendimento?.tipo ?? 0)}
                hookform={viewModel.hookForm}
                onClose={() => {
                    viewModel.handleCadastroEmpreendimentoOpenState(null, false)
                    viewModel.hookForm.setValue('tipo', viewModel.selectedEmpreendimento?.tipo ?? 0)
                }}
                onSubmit={viewModel.handleCadatroEmpreendimentoSubmit}
            />

            <CopyBlocoModal
                open={viewModel.openCopyModal}
                saving={viewModel.saving}
                onSubmit={viewModel.handleConfirmarCopiaBloco}
                onClose={() => viewModel.handleCopyBlocoOpenState(null, false)}
            />

            <CadastroUnidadesBlocoModal
                open={viewModel.openUnidadesModal}
                saving={viewModel.saving}
                bloco={viewModel.selectedBlocoUnidades}
                onSubmit={viewModel.handleConfirmarCadastroUnidades}
                onClose={() => viewModel.handleCadastroUnidadesOpenState(null, false)}
            />

            <DeleteDialog
                open={viewModel.openDeleteModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleBlocoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este item?`}
                onDelete={viewModel.handleConfirmarDeletarBloco} />

            <DeleteDialog
                open={viewModel.openDeleteUnidadeModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleUnidadeDeleteOpenState(null, null, false)}
                title={`Você realmente deseja excluir a unidade ${viewModel.selectedUnidadeDelecao?.descricao ?? ''}? Se for a última do andar, o andar também será excluído.`}
                onDelete={viewModel.handleConfirmarDeletarUnidade} />


            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />
        </>
    )
}